module.exports = __webpack_public_path__ + "static/media/phone-black.bf426a3a.svg";